export const artworks = [
  {
    id: 1,
    src: "/images/art1.jpg",
    title: "Blueberries",
    latin: "Vaccinium corymbosum",
    medium: "Watercolour on Arches hot press paper",
    size: "23 × 31 cm",
    year: "2021",
    category: "Botanical",
    alt: "Botanical watercolour painting of blueberries",
  },
  {
    id: 2,
    src: "/images/art2.jpg",
    title: "Pansy Swiss Giant Blue Blotch",
    latin: "Viola × wittrockiana",
    medium: "Watercolour on Arches hot press paper",
    size: "23 × 31 cm",
    year: "2021",
    category: "Botanical",
    alt: "Watercolour pansy study in blue tones",
  },
  {
    id: 3,
    src: "/images/art3.jpg",
    title: "Single Tulip",
    latin: "Tulipa gesneriana",
    medium: "Watercolour on Arches hot press paper",
    size: "23 × 31 cm",
    year: "2021",
    category: "Botanical",
    alt: "Single tulip botanical watercolour",
  },
  {
    id: 4,
    src: "/images/art4.jpg",
    title: "Camellia",
    latin: "Camellia japonica",
    medium: "Watercolour on Arches hot press paper",
    size: "23 × 31 cm",
    year: "2021",
    category: "Botanical",
    alt: "Camellia flower botanical illustration in watercolour",
  },
  {
    id: 5,
    src: "/images/art5.jpg",
    title: "Paperflower",
    latin: "Bougainvillea glabra",
    medium: "Watercolour on Arches hot press paper",
    size: "23 × 31 cm",
    year: "2021",
    category: "Botanical",
    alt: "Bougainvillea botanical watercolour painting",
  },
  {
    id: 7,
    src: "/images/art7.jpg",
    title: "Benton Lorna",
    latin: "Iris × germanica",
    medium: "Watercolour on Arches hot press paper",
    size: "46 × 61 cm",
    year: "2021",
    category: "Botanical",
    alt: "Large iris botanical painting in watercolour",
  },
  {
    id: 8,
    src: "/images/art8.jpg",
    title: "Common Octopus",
    latin: "Octopus vulgaris",
    medium: "Watercolour on Arches hot press paper",
    size: "23 × 31 cm",
    year: "2022",
    category: "Marine life",
    alt: "Detailed octopus watercolour painting",
  },
  {
    id: 9,
    src: "/images/art9.jpg",
    title: "Hydrangea",
    latin: "Hydrangea macrophylla",
    medium: "Watercolour on Arches hot press paper",
    size: "23 × 31 cm",
    year: "2022",
    category: "Botanical",
    alt: "Hydrangea floral watercolour",
  },
  {
    id: 10,
    src: "/images/art10.jpg",
    title: "Magnolia",
    latin: "Magnolia × soulangeana",
    medium: "Watercolour on Arches hot press paper",
    size: "23 × 31 cm",
    year: "2022",
    category: "Botanical",
    alt: "Magnolia botanical watercolour illustration",
  },
  {
    id: 11,
    src: "/images/art11.jpg",
    title: "Purple Bearded Iris",
    latin: "Iris × germanica",
    medium: "Watercolour on Arches hot press paper",
    size: "23 × 31 cm",
    year: "2022",
    category: "Botanical",
    alt: "Purple iris botanical painting",
  },
  {
    id: 12,
    src: "/images/art12.jpg",
    title: "Daffodil",
    latin: "Narcissus",
    medium: "Watercolour on Arches hot press paper",
    size: "23 × 31 cm",
    year: "2022",
    category: "Botanical",
    alt: "Daffodil floral watercolour artwork",
  },
  {
    id: 13,
    src: "/images/art13.jpg",
    title: "Radishes",
    latin: "Raphanus sativus",
    medium: "Watercolour on Arches hot press paper",
    size: "23 × 31 cm",
    year: "2023",
    category: "Botanical",
    alt: "Botanical radish study painted in watercolour",
  },
  {
    id: 14,
    src: "/images/art14.jpg",
    title: "Passion Fruit",
    latin: "Passiflora edulis Sims",
    medium: "Watercolour on Arches hot press paper",
    size: "23 × 31 cm",
    year: "2023",
    category: "Botanical",
    alt: "Passion fruit botanical watercolour study",
  },
  {
    id: 15,
    src: "/images/art15.jpg",
    title: "Hollyhock",
    latin: "Alcea",
    medium: "Watercolour on Arches hot press paper",
    size: "23 × 31 cm",
    year: "2023",
    category: "Botanical",
    alt: "Hollyhock botanical illustration in watercolour",
  },
  {
    id: 16,
    src: "/images/art16.jpg",
    title: "Kingfisher",
    latin: "Alcedo atthis",
    medium: "Watercolour on Arches hot press paper",
    size: "23 × 31 cm",
    year: "2023",
    category: "Wildlife",
    alt: "Kingfisher bird watercolour painting",
  },
  {
    id: 17,
    src: "/images/art17.jpg",
    title: "Pomegranate",
    latin: "Punica granatum",
    medium: "Watercolour on Arches hot press paper",
    size: "23 × 31 cm",
    year: "2023",
    category: "Botanical",
    alt: "Pomegranate watercolour artwork",
  },
  {
    id: 18,
    src: "/images/art18.jpg",
    title: "Passion Fruit II",
    latin: "Passiflora edulis Sims",
    medium: "Watercolour on Arches hot press paper",
    size: "23 × 31 cm",
    year: "2023",
    category: "Botanical",
    alt: "Second passion fruit botanical watercolour",
  },
  {
    id: 19,
    src: "/images/art19.jpg",
    title: "Carnation",
    latin: "Dianthus caryophyllus",
    medium: "Watercolour on Arches hot press paper",
    size: "23 × 31 cm",
    year: "2023",
    category: "Botanical",
    alt: "Carnation in watercolour",
  },
  {
    id: 20,
    src: "/images/art20.jpg",
    title: "Crocus",
    latin: "Crocus sativus",
    medium: "Watercolour on Arches hot press paper",
    size: "23 × 31 cm",
    year: "2023",
    category: "Botanical",
    alt: "Crocus watercolour",
  },
];